import styled, { css } from "styled-components";
const Link = styled.span`
  color: #5d9cec;
  cursor: pointer;
  user-select: none;
  &:hover {
    text-decoration: underline;
  }
`;

const EmptyLink = styled.span`
  color: #5d9cec;
  cursor: pointer;
  user-select: none;
`;

const UnderlineLink = styled(Link)`
  text-decoration: underline;
`;

export default Link;
export { UnderlineLink, EmptyLink };
